import { render } from "./VNavigationButton.vue?vue&type=template&id=c9b6d63a&scoped=true"
import script from "./VNavigationButton.vue?vue&type=script&lang=js"
export * from "./VNavigationButton.vue?vue&type=script&lang=js"

import "./VNavigationButton.vue?vue&type=style&index=0&id=c9b6d63a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9b6d63a"]])

export default __exports__